export default __webpack_public_path__ + "static/media/social.39d0394d.svg";